// extracted by mini-css-extract-plugin
export var sliderRange = "_pd-2";
export var sliderRoot = "_pd-0";
export var sliderThumb = "_pd-3";
export var sliderTrack = "_pd-1";